<template>
  <div :class="['compass',{compassMedia:dev}]">
    <img
      :src="require('@/assets/img/compass/echartsBg.jpg')"
      class="bg"
      v-if="!dev"
    >
    <img
      v-if="dev"
      :src="require('@/assets/img/compass/echartsBg_m.jpg')"
      class="bg"
    >
    <img
      :class="['header', {headerMedia:dev}]"
      :src="require('@/assets/img/compass/header.png')"
    >
    <div :class="['footer',{footerMedia:dev}]">
      <img
        class="footer_bg"
        :src="require('@/assets/img/compass/footer.png')"
      >
      <div class="footer_text">
        <span class="fTextFixed">转职</span>
        <span class="moving">{{names[max]}}</span>
        <span class="fTextFixed">推荐度</span>
        <span class="moving">{{score[max]}}%</span>
      </div>
    </div>
    <div :class="{mRotate:dev}">

      <div :class="['echarts_box',{echarts_boxMedia:dev}]">

        <div
          class="echarts"
          ref="echarts"
        ></div>

        <div class="items">
          <div
            :class="['names_box',{names_boxMedia:dev}]"
            v-for="(item, index) in names"
            :key="index"
          >
            <img
              :src="require('@/assets/img/compass/textBg.png')"
              class="text_bg"
            />
            <span class="name">{{item}}:</span>
            <span class="score">{{score[index]}}</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
// import ECharts from "vue-echarts";
// import "echarts/lib/chart/radar";

export default {
  data() {
    return {
      option: {
        grid: {
          left: "80%",
          right: "0",
          bottom: "1%",
          containLabel: true
        },
        color: ["#31616d"],
        radar: {
          indicator: [
            { name: "", max: 100 }, //碎梦
            { name: "", max: 100 }, //血河
            { name: "", max: 100 }, //神相
            { name: "", max: 100 }, //铁衣
            { name: "", max: 100 }, //九灵
            { name: "", max: 100 }, //素问
            { name: "", max: 100 } //龙吟
          ],
          splitArea: {
            areaStyle: {
              color: [
                "rgba(224,224,226,.7)",
                "rgba(200,201,202,.7)",
                "rgba(224,224,226,.7)",
                "rgba(200,201,202,.7)",
                "rgba(224,224,226,.7)"
              ]
            }
          }
        },
        series: [
          {
            type: "radar",
            lineStyle: {
              normal: {
                width: 3 // 线条的粗细
              }
            },
            symbolSize: 5, // 圆圈的大小
            data: []
          }
        ]
      },
      names: ["碎梦", "血河", "神相", "铁衣", "九灵", "素问", "龙吟"],
      echartsObj: null
    };
  },
  computed: {
    // 结果数组
    score() {
      return this.$store.state.score;
    },
    // 结果中最大值的下标
    max() {
      let maxNum = Math.max.apply(null, this.score);
      return this.score.indexOf(maxNum);
    },
    // 是否是手机
    dev() {
      return this.$store.state.dev;
    }
  },
  mounted() {
    this.echartsObj = this.$echarts.init(this.$refs.echarts);
    this.echartsObj.setOption(this.option);
    // 修改折线数据
    this.setOptionData();
  },
  methods: {
    setOptionData() {
      this.option.series[0].data.push(this.score);
      this.echartsObj.setOption(this.option);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/com.scss";

.compass {
  @include wh(58%, 100%);
  position: relative;
  z-index: 2;
}
.compassMedia {
  @include wh(100%, 58%);
  overflow: hidden;
}
.mRotate {
  @include LTRBcenter;
  @include wh(100%);
  @include rotate(50%, 50%);
  transform: translate(-50%, -50%) rotate(90deg);
}
.echarts_box {
  @include wh(6.3rem, 6.3rem);
  @include LTRBcenter;
  font-size: 0.4rem;

  span.name {
    @include fontFamily;
    color: #364148;
  }
  span.score {
    font-family: "Microsoft YaHei";
    color: #6798a0;
    margin-left: 5px;
  }
}
.echarts_boxMedia {
  @include wh(4rem, 4rem);
  font-size: 0.3rem;
}

.echarts {
  @include wh(100%, 100%);
  background: rgba(0, 0, 0, 0);
  z-index: 1;
}
.bg {
  @include bgObject;
}
.text_bg {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.header {
  @include wh(6.38rem);
  @include LRcenter;
  top: 0.45rem;
}
.headerMedia {
  @include TBcenter;
  @include rotate(50%, 50%);
  transform: translate(-2%, -50%) rotate(90deg);
}
.footer {
  @include LRcenter;
  @include wh(7.6rem, 1.39rem);
  line-height: 1.39rem;
  bottom: 0.4rem;

  .footer_bg {
    position: absolute;
    left: 0;
    top: 0;
    @include wh(100%);
    display: block;
  }
}
.footerMedia {
  @include TBcenter;
  @include rotate(50%, 50%);
  transform: translate(-89%, -50%) rotate(90deg);
}
.footer_text {
  @include LRcenter;
  @include wh(100%, 100%);
  z-index: 5;
  font-size: 0.3rem;
  text-align: center;

  .fTextFixed {
    color: #cdd4da;
    font-family: "Microsoft YaHei";
    vertical-align: middle;
  }
  .moving {
    color: #fff;
    @include fontFamily;
    font-size: 0.5rem;
    margin: 0 15px;
    vertical-align: middle;
  }
  .moving:last-child {
    margin-right: 0;
    font-family: "Microsoft YaHei";
  }
}

.items {
  .names_box {
    display: block;
    @include wh(2.56rem, 0.63rem);
    line-height: 0.63rem;
    text-align: center;
    position: absolute;
  }
  .names_boxMedia {
    @include wh(2rem, 0.49rem);
    line-height: 0.5rem;
  }
  .names_box:nth-child(1) {
    @include LRcenter;
    top: -0.1rem;
  }
  .names_boxMedia:nth-child(1) {
    top: -0.15rem;
  }
  .names_box:nth-child(2) {
    left: -1.3rem;
    top: 1rem;
  }
  .names_boxMedia:nth-child(2) {
    left: -1.2rem;
    top: 0.6rem;
  }
  .names_box:nth-child(3) {
    left: -1.9rem;
    top: 3.2rem;
  }
  .names_boxMedia:nth-child(3) {
    left: -1.5rem;
    top: 2.1rem;
  }
  .names_box:nth-child(4) {
    right: 3.5rem;
    top: 5.55rem;
  }
  .names_boxMedia:nth-child(4) {
    right: 2.2rem;
    top: 3.5rem;
  }
  .names_box:nth-child(5) {
    right: 0.2rem;
    top: 5.55rem;
  }
  .names_boxMedia:nth-child(5) {
    right: -0.2rem;
    top: 3.5rem;
  }
  .names_box:nth-child(6) {
    right: -1.9rem;
    top: 3.2rem;
  }
  .names_boxMedia:nth-child(6) {
    right: -1.5rem;
    top: 2.1rem;
  }
  .names_box:nth-child(7) {
    right: -1.3rem;
    top: 1rem;
  }
  .names_boxMedia:nth-child(7) {
    right: -1.2rem;
    top: 0.6rem;
  }
}
</style>

